
<div  *ngIf="timeline.length>0" class="alert alert-dismissible bg-secondary text-white border-0 show" role="alert">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">×</span>
  </button>
  <span [innerHTML]="lastact?.TIMELINE_ACTIVITY"></span>
</div>